import type { HTMLAttributes, ReactNode } from 'react';
import './components.css';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  padded?: boolean;
  tone?: 'default' | 'soft' | 'warn' | 'accent' | 'danger';
}
export function Card({ title, subtitle, actions, padded = true, tone = 'default', className = '', children, ...rest }: CardProps) {
  return (
    <section className={`k-card k-card--${tone} ${padded ? 'k-card--padded' : ''} ${className}`} {...rest}>
      {(title || actions) && (
        <header className="k-card__header">
          <div>
            {title && <h3 className="k-card__title">{title}</h3>}
            {subtitle && <div className="k-card__subtitle">{subtitle}</div>}
          </div>
          {actions && <div className="k-card__actions">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}

export function Stat({ label, value, hint }: { label: ReactNode; value: ReactNode; hint?: ReactNode }) {
  return (
    <div className="k-card k-card--padded k-stat">
      <div className="k-stat__label">{label}</div>
      <div className="k-stat__value">{value}</div>
      {hint && <div className="k-stat__hint">{hint}</div>}
    </div>
  );
}
